


import store from '../store/store.js'



export const initFBShowcaseWdgts = (isInitialFetch = true, onlyFeedback = false) => {
  


  return new Promise((resolve,reject) => {    
    return store.dispatch('dash/QUERY_FEEDBACK', {
      isInitialFetch
    }).then(() => {     
      
        if (onlyFeedback) {
          resolve()
          return
        }

        return store.dispatch('dash/FETCH_SHOWCASED_IDs').then(() => {
          return store.dispatch('dash/SYNC_WIDGETS').then(() => {
            resolve()
          }).catch((e) => {
            console.log(e)
            reject()
          })          
        }).catch((e) => {          
          reject()
        })     


    }).catch((e) => {
      reject()
    })


  })



}
